import React from "react";
import { useRoute } from "@react-navigation/native";
import { RootRouteProps } from "router/types/stack";

import { View } from "react-native";
import {
  Text,
  Error,
  Header,
  Loading,
  CategoryCard,
  ListContainer,
} from "component";

import { colors, strings } from "asset/constant";
import { css } from "style";

import { useCategory } from "client/api";
import { useRecoilValue } from "recoil";
import RouteParamsAtom from "store/recoil/routeParamsAtom";

export default function Category() {
  // const params = useRoute<RootRouteProps<"category">>().params;

  const routeParams = useRecoilValue(RouteParamsAtom);

  const { data, error, refetch, isError, isLoading, isRefetching } =
    useCategory(routeParams?.company_id);
  // const { data, error, refetch, isError, isLoading, isRefetching } =
  //   useCategory(params.id);

  const _renderContent = () => {
    if (isLoading) {
      return <Loading />;
    }

    if (isError) {
      return <Error error={error} reset={refetch} loading={isRefetching} />;
    }

    return data?.data?.map((category: CategoryT, key: number) => {
      return <CategoryCard key={String(key)} category={category} />;
    });
  };

  return (
    <>
      <Header
        title={strings.category}
        subTitle={routeParams?.title + " (" + routeParams?.cto + ")"}
      />

      {routeParams?.desc && (
        <View
          style={{
            margin: 12,
            padding: 12,
            borderRadius: 12,
            ...css.shadowForWeb(5),
            backgroundColor: colors.white,
          }}
        >
          <Text style={{ lineHeight: 24 }}>{routeParams?.desc}</Text>
        </View>
      )}

      <ListContainer>{_renderContent()}</ListContainer>
    </>
  );
}
